import clsx from 'clsx';

import {VideoPlayer} from '@/components/video';

type Props = {
	id: string;
	title: string;
};

export const Video = ({id, title}: Props) => {
	return (
		<div className={clsx('my-10', 'rounded', 'overflow-hidden')}>
			<VideoPlayer videoId={id} title={title} />
		</div>
	);
};
